import { useEffect, useRef } from 'react';

// Run code every x milliseconds
export const useInterval = (callback, delay, runOnInitialLoad) => {
  const savedCallback = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (runOnInitialLoad) {
      savedCallback.current();
    }
  }, []);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };

    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};
